(function webpackUniversalModuleDefinition(e, r) {
  if (typeof exports === "object" && typeof module === "object") module.exports = r(require("classnames"), require("prop-types"), require("rc-checkbox/es"), require("react"), require("shallowequal"), require("tslib"));else if (typeof define === "function" && define.amd) define(["classnames", "prop-types", "rc-checkbox/es", "react", "shallowequal", "tslib"], r);else if (typeof exports === "object") exports["@mq/aurora-components"] = r(require("classnames"), require("prop-types"), require("rc-checkbox/es"), require("react"), require("shallowequal"), require("tslib"));else e["@mq/aurora-components"] = r(e["classnames"], e["prop-types"], e["rc-checkbox/es"], e["react"], e["shallowequal"], e["tslib"]);
})(typeof self !== "undefined" ? self : this, function (e, r, o, a, t, u) {
  return function () {
    var c = {
      6215: function (e) {
        e.exports = {
          "aurora-checkbox": "aurora-checkbox",
          auroraCheckbox: "aurora-checkbox",
          "aurora-checkbox-wrapper": "aurora-checkbox-wrapper",
          auroraCheckboxWrapper: "aurora-checkbox-wrapper",
          "aurora-checkbox-disabled": "aurora-checkbox-disabled",
          auroraCheckboxDisabled: "aurora-checkbox-disabled",
          "aurora-checkbox-inner": "aurora-checkbox-inner",
          auroraCheckboxInner: "aurora-checkbox-inner",
          "aurora-checkbox-input": "aurora-checkbox-input",
          auroraCheckboxInput: "aurora-checkbox-input",
          "aurora-checkbox-checked": "aurora-checkbox-checked",
          auroraCheckboxChecked: "aurora-checkbox-checked",
          "aurora-checkbox-indeterminate": "aurora-checkbox-indeterminate",
          auroraCheckboxIndeterminate: "aurora-checkbox-indeterminate",
          "aurora-checkbox-lg": "aurora-checkbox-lg",
          auroraCheckboxLg: "aurora-checkbox-lg",
          "aurora-checkbox-sm": "aurora-checkbox-sm",
          auroraCheckboxSm: "aurora-checkbox-sm",
          none: "none",
          "aurora-checkbox-wrapper-lg": "aurora-checkbox-wrapper-lg",
          auroraCheckboxWrapperLg: "aurora-checkbox-wrapper-lg",
          "aurora-checkbox-wrapper-sm": "aurora-checkbox-wrapper-sm",
          auroraCheckboxWrapperSm: "aurora-checkbox-wrapper-sm",
          "aurora-checkbox-group": "aurora-checkbox-group",
          auroraCheckboxGroup: "aurora-checkbox-group",
          "aurora-checkbox-group-item": "aurora-checkbox-group-item",
          auroraCheckboxGroupItem: "aurora-checkbox-group-item",
          "aurora-checkbox-group-item-active": "aurora-checkbox-group-item-active",
          auroraCheckboxGroupItemActive: "aurora-checkbox-group-item-active",
          auroraCheckboxEffect: "auroraCheckboxEffect"
        };
      },
      8257: function (e, r, o) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: true
        });
        r.CheckboxGroupItem = void 0;
        var a = o(4780);
        var t = o(9297);
        var u = o(1040);
        var c = o(6215);
        var n = function (e) {
          a.__extends(CheckboxGroupItem, e);
          function CheckboxGroupItem() {
            var r = e !== null && e.apply(this, arguments) || this;
            r.onChange = function () {
              var e = r.props,
                o = e.option,
                a = e.onChange;
              a(o);
            };
            return r;
          }
          CheckboxGroupItem.prototype.render = function () {
            var e = this.props,
              r = e.prefixCls,
              o = e.option,
              a = e.checked,
              n = e.isGroupDisabled,
              i = e.theme,
              s = i === void 0 ? c : i,
              p = e.size,
              h = e.active;
            return t.createElement(u.Checkbox, {
              disabled: "disabled" in o ? o.disabled : n,
              value: o.value,
              checked: a,
              onChange: this.onChange,
              className: s.auroraCheckboxGroupItem,
              size: p,
              active: h
            }, o.label);
          };
          return CheckboxGroupItem;
        }(t.Component);
        r.CheckboxGroupItem = n;
      },
      8130: function (e, r, o) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: true
        });
        r.CheckboxGroup = void 0;
        var a = o(4780);
        var t = o(9297);
        var u = o(4229);
        var c = o(9558);
        var n = o(4058);
        var i = o(8257);
        var s = o(6215);
        var p = function (e) {
          a.__extends(CheckboxGroup, e);
          function CheckboxGroup(r) {
            var o = e.call(this, r) || this;
            o.toggleOption = function (e) {
              var r = o.state.value.indexOf(e.value);
              var t = a.__spreadArray([], o.state.value);
              if (r === -1) {
                t.push(e.value);
              } else {
                t.splice(r, 1);
              }
              if (!("value" in o.props)) {
                o.setState({
                  value: t
                });
              }
              var u = o.props.onChange;
              if (u) {
                u(t);
              }
              o.setState({
                activeOption: e.value
              });
            };
            o.onKeyPress = function (e) {
              var r = e.key,
                t = e.shiftKey;
              var u = o.state,
                c = u.activeOption,
                n = u.value;
              var i = o.props.onChange;
              var s = o.getOptions();
              if (!s || s.length < 1) {
                return;
              }
              if (r === "ArrowDown" || r === "ArrowUp" || r === "Tab") {
                e.preventDefault();
                if (!c) {
                  o.setState({
                    activeOption: s[0].value
                  });
                  return;
                }
                if (r === "ArrowDown" || !t && r === "Tab") {
                  for (var p = 0; p < s.length; p++) {
                    if (s[p].value === c && s[p + 1]) {
                      o.setState({
                        activeOption: s[p + 1].value
                      });
                      break;
                    }
                  }
                  return;
                } else if (r === "ArrowUp" || t && r === "Tab") {
                  for (var p = 0; p < s.length; p++) {
                    if (s[p].value === c && s[p - 1]) {
                      o.setState({
                        activeOption: s[p - 1].value
                      });
                      break;
                    }
                  }
                  return;
                }
              } else if ((r === "Enter" || r === " ") && c) {
                e.preventDefault();
                var h = n.indexOf(c) > -1 ? n.filter(function (e) {
                  return e !== c;
                }) : a.__spreadArray(a.__spreadArray([], n), [c]);
                o.setState({
                  value: h
                }, function () {
                  if (i) {
                    i(o.state.value);
                  }
                });
              }
            };
            o.state = {
              value: r.value || r.defaultValue || [],
              activeOption: ""
            };
            return o;
          }
          CheckboxGroup.prototype.getChildContext = function () {
            return {
              checkboxGroup: {
                toggleOption: this.toggleOption,
                value: this.state.value,
                disabled: this.props.disabled
              }
            };
          };
          CheckboxGroup.getDerivedStateFromProps = function (e) {
            if ("value" in e) {
              return {
                value: e.value || []
              };
            }
            return null;
          };
          CheckboxGroup.prototype.shouldComponentUpdate = function (e, r) {
            return !c(this.props, e) || !c(this.state, r);
          };
          CheckboxGroup.prototype.getOptions = function () {
            var e = this.props.options;
            return e.map(function (e) {
              if (typeof e === "string") {
                return {
                  label: e,
                  value: e
                };
              }
              return e;
            });
          };
          CheckboxGroup.prototype.render = function () {
            var e = this;
            var r = this.state,
              o = r.value,
              a = r.activeOption;
            var u = this.props,
              c = u.className,
              s = u.options,
              p = u.theme,
              h = u.size,
              l = u.disabled,
              b = u.children;
            if (!p) {
              return null;
            }
            var x = b;
            if (s && s.length > 0) {
              x = this.getOptions().map(function (r) {
                return t.createElement(i.CheckboxGroupItem, {
                  prefixCls: p.auroraCheckboxGroup,
                  option: r,
                  key: r.value,
                  checked: o.indexOf(r.value) !== -1,
                  isGroupDisabled: l,
                  onChange: e.toggleOption,
                  size: h,
                  active: a === r.value
                });
              });
            }
            var k = n(p.auroraCheckboxGroup, c);
            return t.createElement("div", {
              className: k,
              onKeyDown: this.onKeyPress
            }, x);
          };
          CheckboxGroup.defaultProps = {
            options: [],
            theme: s
          };
          CheckboxGroup.childContextTypes = {
            checkboxGroup: u.any
          };
          return CheckboxGroup;
        }(t.Component);
        r.CheckboxGroup = p;
        r.default = p;
      },
      5688: function (e, r, o) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: true
        });
        r.CheckboxGroup = void 0;
        var a = o(8130);
        Object.defineProperty(r, "CheckboxGroup", {
          enumerable: true,
          get: function () {
            return a.CheckboxGroup;
          }
        });
      },
      1040: function (e, r, o) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: true
        });
        r.Checkbox = void 0;
        var a = o(4780);
        var t = o(9297);
        var u = o(9558);
        var c = o(4058);
        var n = o(5231);
        var i = o(5688);
        var s = o(6215);
        var p = function (e) {
          a.__extends(Checkbox, e);
          function Checkbox() {
            return e !== null && e.apply(this, arguments) || this;
          }
          Checkbox.prototype.shouldComponentUpdate = function (e, r, o) {
            var a = this.context.checkboxGroup;
            return !u(this.props, e) || !u(this.state, r) || !u(a, o.checkboxGroup);
          };
          Checkbox.prototype.render = function () {
            var e, r;
            var o = this.props,
              u = o.className,
              i = o.children,
              s = o.indeterminate,
              p = o.style,
              h = o.onMouseEnter,
              l = o.onMouseLeave,
              b = o.theme,
              x = o.size,
              k = o.active,
              v = a.__rest(o, ["className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "theme", "size", "active"]);
            if (!b) {
              return null;
            }
            var f = a.__assign({}, v);
            var d = c(u, b.auroraCheckboxWrapper, (e = {}, e[b.auroraCheckboxWrapperSm] = x === "small", e[b.auroraCheckboxWrapperLg] = x === "large", e[b.auroraCheckboxGroupItemActive] = !!k, e));
            var C = c((r = {}, r[b.auroraCheckboxIndeterminate] = s, r[b.auroraCheckboxSm] = x === "small", r[b.auroraCheckboxLg] = x === "large", r));
            return t.createElement("label", {
              className: d,
              style: p,
              onMouseEnter: h,
              onMouseLeave: l
            }, t.createElement(n.default, a.__assign({}, f, {
              prefixCls: b.auroraCheckbox,
              className: C
            })), i !== undefined ? t.createElement("span", null, i) : null);
          };
          Checkbox.defaultProps = {
            indeterminate: false,
            theme: s
          };
          return Checkbox;
        }(t.Component);
        r.Checkbox = p;
        p.Group = i.CheckboxGroup;
        r.default = p;
      },
      4058: function (r) {
        "use strict";

        r.exports = e;
      },
      4229: function (e) {
        "use strict";

        e.exports = r;
      },
      5231: function (e) {
        "use strict";

        e.exports = o;
      },
      9297: function (e) {
        "use strict";

        e.exports = a;
      },
      9558: function (e) {
        "use strict";

        e.exports = t;
      },
      4780: function (e) {
        "use strict";

        e.exports = u;
      }
    };
    var n = {};
    function __webpack_require__(e) {
      var r = n[e];
      if (r !== undefined) {
        return r.exports;
      }
      var o = n[e] = {
        exports: {}
      };
      c[e](o, o.exports, __webpack_require__);
      return o.exports;
    }
    var i = {};
    !function () {
      "use strict";

      var e = i;
      Object.defineProperty(e, "__esModule", {
        value: true
      });
      e.Checkbox = void 0;
      var r = __webpack_require__(1040);
      Object.defineProperty(e, "Checkbox", {
        enumerable: true,
        get: function () {
          return r.Checkbox;
        }
      });
    }();
    return i;
  }();
});